// SEQ-192: the shared money elements. Anything a screen renders through these
// carries data-seq-private, so the report widget blurs it in the screenshot
// without relying on the text sweep in lib/seqReportPrivacy.ts (which cannot
// tell a bare "500" or "85" from a count). New money cells and rate inputs
// should use these instead of a bare <span>, <td> or <input>.
//
// Written with createElement, not JSX, so the deno tests can render it with
// the react and react-dom the app already depends on.

import { createElement, type ComponentPropsWithoutRef, type ReactElement } from "react";
import { SEQ_PRIVATE_ATTRIBUTE } from "../lib/seqReportPrivacy.ts";

// Plain DOM tags only. A component here might not forward the attribute.
type MoneyTag = "span" | "div" | "td" | "th" | "strong" | "b" | "p";
type MoneyProps<T extends MoneyTag> = { as?: T } & Omit<ComponentPropsWithoutRef<T>, "as">;

// A money figure or cell. `as` picks the element: "td" for a table cell,
// "span" (the default) inline.
export function Money<T extends MoneyTag = "span">({ as, ...rest }: MoneyProps<T>): ReactElement {
  const tag: MoneyTag = as ?? "span";
  return createElement(tag, { ...rest, [SEQ_PRIVATE_ATTRIBUTE]: "" });
}

// A form field that holds a rate, amount, price, cost, value or margin.
export function MoneyInput(props: ComponentPropsWithoutRef<"input">): ReactElement {
  return createElement("input", { ...props, [SEQ_PRIVATE_ATTRIBUTE]: "" });
}
